export const GAME_FACT_START = 'generic_start'

export const GAME_FACT_RUGBY_STOP = 'rugby_stop'
export const GAME_FACT_ESSAI = 'rugby_essai'
export const GAME_FACT_TRANSFORMATION = 'rugby_transformation'
export const GAME_FACT_PENALITE = 'rugby_penalite'
export const GAME_FACT_SHOOTOUTPENALTY = 'rugby_shootoutpenalty'
export const GAME_FACT_DROP = 'rugby_drop'
export const GAME_FACT_FAULT = 'rugby_fault'
export const GAME_FACT_YELLOWCARD = 'rugby_yellowcard'
export const GAME_FACT_REDCARD = 'rugby_redcard'
export const GAME_FACT_REPLACEMENT = 'rugby_replacement'
export const GAME_FACT_REPLACEMENT_IN = 'rugby_replacement_in'
export const GAME_FACT_REPLACEMENT_OUT = 'rugby_replacement_out'
export const GAME_FACT_COMMENT = 'rugby_comment'
export const GAME_FACT_RUGBY_STAR = 'rugby_star'

export const GAME_FACT_SOCCER_STOP = 'soccer_stop'
export const GAME_FACT_SOCCER_BUT = 'soccer_but'
export const GAME_FACT_SOCCER_SHOT = 'soccer_shot'
export const GAME_FACT_SOCCER_PENALTY = 'soccer_penalty'
export const GAME_FACT_SOCCER_SHOOTOUTPENALTY = 'soccer_shootoutpenalty'
export const GAME_FACT_SOCCER_FAULT = 'soccer_fault'
export const GAME_FACT_SOCCER_YELLOWCARD = 'soccer_yellowcard'
export const GAME_FACT_SOCCER_REDCARD = 'soccer_redcard'
export const GAME_FACT_SOCCER_REPLACEMENT = 'soccer_replacement'
export const GAME_FACT_SOCCER_REPLACEMENT_IN = 'soccer_replacement_in'
export const GAME_FACT_SOCCER_REPLACEMENT_OUT = 'soccer_replacement_out'
export const GAME_FACT_SOCCER_COMMENT = 'soccer_comment'
export const GAME_FACT_SOCCER_STAR = 'soccer_star'

export const GAME_FACT_BASKET_TWOPOINTS = 'basket_two_points'
export const GAME_FACT_BASKET_THREEPOINTS = 'basket_three_points'
export const GAME_FACT_BASKET_FREETHROW = 'basket_free_throw'
export const GAME_FACT_BASKET_FAULT = 'basket_fault'
export const GAME_FACT_BASKET_TECHNICAL = 'basket_technical'
export const GAME_FACT_BASKET_COMMENT = 'basket_comment'
export const GAME_FACT_BASKET_STOP = 'basket_stop'
export const GAME_FACT_BASKET_TIMEOUT = 'basket_timeout'
// ONLY WEBHOOK
export const GAME_FACT_BASKET_DEFENSIVE_REBOUND = 'basket_defensive_rebound'
export const GAME_FACT_BASKET_OFFENSIVE_REBOUND = 'basket_offensive_rebound'
export const GAME_FACT_BASKET_SUFFERED_FAULT = 'basket_suffered_fault'
export const GAME_FACT_BASKET_COUNTER = 'basket_counter'
export const GAME_FACT_BASKET_SUFFERED_COUNTER = 'basket_suffered_counter'
export const GAME_FACT_BASKET_DECISIVE_PASS = 'basket_decisive_pass'
export const GAME_FACT_BASKET_REPLACEMENT = 'basket_replacement'
export const GAME_FACT_BASKET_REPLACEMENT_IN = 'basket_replacement_in'
export const GAME_FACT_BASKET_REPLACEMENT_OUT = 'basket_replacement_out'
export const GAME_FACT_BASKET_TURNOVER = 'basket_turnover'
export const GAME_FACT_BASKET_INTERCEPTION = 'basket_interception'

//Handball
//Arrêt
export const GAME_FACT_HANDBALL_STOP = 'handball_stop'
//But
export const GAME_FACT_HANDBALL_GOAL = 'handball_goal'
//Tir au but
export const GAME_FACT_HANDBALL_SHOOTOUT = 'handball_shootout';
//Tirs au But - 'jet de sept mètres'
export const GAME_FACT_HANDBALL_PENALTY = 'handball_penalty'
//Avertissement
export const GAME_FACT_HANDBALL_YELLOWCARD = 'handball_yellowcard'
//TODO add YELLOWCARDSECOND (bis) to be iso with Live
//Exclusion temporaire
export const GAME_FACT_HANDBALL_TWOMIN_SUSPENSION = 'handball_two_min_suspension'
//Disqualification
export const GAME_FACT_HANDBALL_REDCARD = 'handball_redcard'
//Temps mort
export const GAME_FACT_HANDBALL_TIMEOUT = 'handball_timeout'
//Balle perdue
export const GAME_FACT_HANDBALL_TURNOVER = 'handball_turnover'
export const GAME_FACT_HANDBALL_COMMENT = 'handball_comment'
//Fault & replacement ?
//minutes played:
export const GAME_FACT_HANDBALL_REPLACEMENT = 'handball_replacement'

//SUCCEED - FAILED - TRY // Front logic
/** GF SUCCESS DEPENDANT
 *  details.isSucceed = 1;
    details.butSucced = 1;
    details.dropSucced = 1;
    details.transformSucced = 1;
    details.penalitySucced = 1;
 */
//BASKET
export const GAME_FACT_BASKET_TWOPOINTS_SUCCEEDED = 'basket_two_points_succeeded'
export const GAME_FACT_BASKET_THREEPOINTS_SUCCEEDED = 'basket_three_points_succeeded'
export const GAME_FACT_BASKET_FREETHROW_SUCCEEDED = 'basket_free_throw_succeeded'

export const GAME_FACT_BASKET_TWOPOINTS_FAILED = 'basket_two_points_failed'
export const GAME_FACT_BASKET_THREEPOINTS_FAILED = 'basket_three_points_failed'
export const GAME_FACT_BASKET_FREETHROW_FAILED = 'basket_free_throw_failed'

export const GAME_FACT_BASKET_TWOPOINTS_TRY = 'basket_two_points_try'
export const GAME_FACT_BASKET_THREEPOINTS_TRY = 'basket_three_points_try'
export const GAME_FACT_BASKET_FREETHROW_TRY = 'basket_free_throw_try'
//RUGBY
export const GAME_FACT_DROP_SUCCEEDED = 'rugby_drop_succeeded'
export const GAME_FACT_DROP_FAILED = 'rugby_drop_failed'
export const GAME_FACT_DROP_TRY = 'rugby_drop_try'

export const GAME_FACT_TRANSFORMATION_SUCCEEDED = 'rugby_transformation_succeeded'
export const GAME_FACT_TRANSFORMATION_FAILED = 'rugby_transformation_failed'
export const GAME_FACT_TRANSFORMATION_TRY = 'rugby_transformation_try'

export const GAME_FACT_PENALITE_SUCCEEDED = 'rugby_penalite_succeeded'
export const GAME_FACT_PENALITE_FAILED = 'rugby_penalite_failed'
export const GAME_FACT_PENALITE_TRY = 'rugby_penalite_try'

export const GAME_FACT_SHOOTOUTPENALTY_SUCCEEDED = 'rugby_shootoutpenalty_succeeded'
export const GAME_FACT_SHOOTOUTPENALTY_FAILED = 'rugby_shootoutpenalty_failed'
export const GAME_FACT_SHOOTOUTPENALTY_TRY = 'rugby_shootoutpenalty_try'
//SOCCER
export const GAME_FACT_SOCCER_BUT_SUCCEEDED = 'soccer_but_succeeded'
export const GAME_FACT_SOCCER_BUT_FAILED = 'soccer_but_failed'
export const GAME_FACT_SOCCER_BUT_TRY = 'soccer_but_try'

export const GAME_FACT_SOCCER_PENALTY_SUCCEEDED = 'soccer_penalty_succeeded'
export const GAME_FACT_SOCCER_PENALTY_FAILED = 'soccer_penalty_failed'
export const GAME_FACT_SOCCER_PENALTY_TRY = 'soccer_penalty_try'

export const GAME_FACT_SOCCER_SHOOTOUTPENALTY_SUCCEEDED = 'soccer_shootoutpenalty_succeeded'
export const GAME_FACT_SOCCER_SHOOTOUTPENALTY_FAILED = 'soccer_shootoutpenalty_failed'
export const GAME_FACT_SOCCER_SHOOTOUTPENALTY_TRY = 'soccer_shootoutpenalty_try'


//HANDBALL
export const GAME_FACT_HANDBALL_GOAL_SUCCEEDED = 'handball_goal_succeeded'
export const GAME_FACT_HANDBALL_GOAL_FAILED = 'handball_goal_failed'
export const GAME_FACT_HANDBALL_GOAL_TRY = 'handball_goal_try'

export const GAME_FACT_HANDBALL_PENALTY_SUCCEEDED = 'handball_penalty_succeeded'
export const GAME_FACT_HANDBALL_PENALTY_FAILED = 'handball_penalty_failed'
export const GAME_FACT_HANDBALL_PENALTY_TRY = 'handball_penalty_try'

//Tir au but
export const GAME_FACT_HANDBALL_SHOOTOUT_SUCCEEDED = 'handball_shootout_succeeded';
export const GAME_FACT_HANDBALL_SHOOTOUT_FAILED = 'handball_shootout_failed';
export const GAME_FACT_HANDBALL_SHOOTOUT_TRY = 'handball_shootout_try';

//TODO & import CSV
//handball_shootout


export const reasonListSoccerStop = [
  {id : 'end', value : `Fin du match`, disabled : (match) => match.period < 1},
  {id : 'next', value : `Période suivante`, disabled : (match) => match.period >= 4},
  {id : 'tab', value : `Tirs au but`, disabled : (match) => match.period === 0 || match.period === 5}
]

export const reasonListRugbyStop = [
  {id : 'end', value : `Fin du match`, disabled : (match) => match.period < 1},
  {id : 'next', value : `Période suivante`, disabled : (match) => match.period >= 4},
  {id : 'tab', value : `Tirs au but`, disabled : (match) => match.period === 0 || match.period === 5}
]

export const reasonListBasketStop = [
  {id : 'end', value : `Fin du match`, disabled : (match) => match.period < 3},
  {id : 'next', value : `Quart temps suivant`, disabled : (match) => false},
]

//TODO
export const reasonListHandballStop = [
  {id: 'end', value: `Fin du match`, disabled: (match) => match.period < 3},
  {id: 'next', value: `Période suivante`, disabled: (match) => match.period > 2},
  //Overtime
  {id: 'ot', value: `Prolongation`, disabled: (match) => match.period !== 3},
  {id: 'ot2', value: `Prolongation suivante`, disabled: (match) => match.period !== 5},
  //Shoot out
  {id: 'so', value: `Tirs au but`, disabled: (match) => match.period < 2 || match.period>=9}
]

export const reasonListRugby = [
  {id : 'horsjeu', value : `Hors jeux`},
  {id : 'maulecroule', value : `Maul écroulé`},
  {id : 'meleeecroule', value : `Mêlée écroulée`},
  {id : 'plaquageanticipe', value : `Plaquage anticipé`},
  {id : 'tenirleballon', value : `Tenir le ballon`},
  {id : 'jeudeloyal', value : `Jeu déloyal`},
  {id : 'autres', value : `Autres`},
]

export const reasonListSoccer = [
{id : 'faute', value : `Faute`},
{id : 'contestation', value : `Contestation`},
{id : 'simulation', value : `Simulation`},
{id : 'gaintemps', value : `Gain de temps`},
{id : 'autres', value : `Autres`},
]

export const reasonListSoccerRedCard = [
{id : 'lastdef', value : `Dernier défenseur`},
{id : 'dangerous', value : `Faute dangereuse`},
{id : 'autres', value : `Autres`},
]

export const typeShotListSoccer = [
  {id : 'cadre', value : `Cadré`},
  {id : 'nocadre', value : `Non cadré`},
  {id : 'poteau', value : `Poteaux`},
  {id : 'transversale', value : `Barre transversale`},
]

// UNUSED
export const reasonListSoccerReplacement = [
{id : 'temporaire', value : `Temporaire`},
{id : 'normal', value : `Normal`},
{id : 'firstline', value : `Remplacement 1ère ligne`},
]

export const reasonListRugbyReplacement = [
  {id : 'normal', value : `Normal`},
  {id : 'blessure', value : `Blessure`},
  {id : 'tactique', value : `Tactique`},
  {id : 'cartonorange', value : `Carton orange`},
  ]

//handball
export const reasonListHandballPenalty = [
  {id: 'foulIn6mArea', value: `Faute dans la zone des 6 mètres`},
  {id: 'illegalBlocking', value: `Blocage illégal`},
  {id: 'autres', value: `Autres`}
]

export const reasonListHandballYellowCard = [
  {id: 'minorFoul', value: `Faute mineure`},
  {id: 'unsportingBehavior', value: `Comportement antisportif`},
  {id: 'dangerousPlay', value: `Jeu dangereux`},
  {id: 'autres', value: `Autres`}
]

export const reasonListHandballRedCard = [
  {id: 'severeFoul', value: `Faute grave`},
  {id: 'violentConduct', value: `Conduite violente`},
  {id: 'threeTwoMinSuspensions', value: `Trois exclusions temporaires`},
  {id: 'autres', value: `Autres`}
]

export const reasonListHandballTwoMinSuspension = [
  {id: 'repeatedFouls', value: `Fautes répétées`},
  {id: 'unsportingBehavior', value: `Comportement antisportif`},
  {id: 'dangerousPlay', value: `Jeu dangereux`},
  {id: 'autres', value: `Autres`}
]

export const reasonListHandballTurnover = [
  {id: 'badPass', value: `Mauvaise passe`},
  {id: 'interception', value: `Interception par l'adversaire`},
  {id: 'footFault', value: `Faute de pied`},
  {id: 'traveling', value: `Marcher avec la balle`},
  {id: 'doubleDribble', value: `Double dribble`},
  {id: 'offensiveFoul', value: `Faute offensive`},
  {id: 'ballOutOfBounds', value: `Balle sortie des limites`},
  {id: 'autres', value: `Autres`}
]